const getApiEndpoint = (path) => `*/eservice/api/${path}`;

export { getApiEndpoint };

